var map = {
	"./symbol_0.png": 78627,
	"./symbol_1.png": 88794,
	"./symbol_2.png": 48689,
	"./symbol_3.png": 16648,
	"./symbol_4.png": 96263,
	"./symbol_5.png": 4126,
	"./symbol_6.png": 40853,
	"./symbol_7.png": 29228
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70982;